// extracted by mini-css-extract-plugin
export default {"target_purchase":"N0","btns":"O0","btn":"P0","active":"Q0","footer":"R0"};
    if(module.hot) {
      // 1711394580225
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  